import React from 'react'
import PendingChart from '../../../components/PendingChart'

const PendingProjectsIgr = ({ t, singleCard }) => {
    return (
        <div className="pending">
            <div className="c-pending">
                <PendingChart title={t('one_pager_report.pending_legal_validity')} value={singleCard?.pendingLegalValidity} />
                <PendingChart title={t('one_pager_report.projects_with_deadlines')} value={singleCard?.projectsOverdueDisbursement} />
            </div>
        </div>
    )
}

export default PendingProjectsIgr